import { ReactNode, useCallback } from 'react';

import {
   VisitDraftPrescriptionsQuantity,
   VisitDraftPrescriptionsQuantityQuery,
} from '@dreryk/egabinet-visit-frontend-api';

import { useCqrsGet } from '@dreryk/command-query-react-common';
import { ModalWidth, ShowModalEventInterceptor, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { prescriptionsTranslationKeys, visitTranslationKeys } from '../../../../translations';

type NotAcceptedPrescriptionShowModalEventInterceptorProps = {
   readonly visitId: number;
   readonly children: ReactNode;
};

export const NotAcceptedPrescriptionShowModalEventInterceptor = ({
   visitId,
   children,
}: NotAcceptedPrescriptionShowModalEventInterceptorProps): JSX.Element => {
   const push = useHistoryPushWithBackAction(true);

   const {
      data: draftPrescriptionsQuantity = { numberOfDraftPrescriptions: 0 },
   } = useCqrsGet<VisitDraftPrescriptionsQuantity>(() => {
      const query = new VisitDraftPrescriptionsQuantityQuery();
      query.visitId = visitId;
      return query;
   });

   const onCancel = useCallback((): void => {
      push(visitPaths.getPrescriptionsPath({ params: { visitId: visitId } }), {
         label: visitTranslationKeys.goBackToVisit,
      });
   }, [push, visitId]);

   return (
      <ShowModalEventInterceptor
         shouldShowModal={Boolean(draftPrescriptionsQuantity.numberOfDraftPrescriptions)}
         title={prescriptionsTranslationKeys.notAcceptedPrescriptionsMessage.title}
         confirmationButtonLabel={prescriptionsTranslationKeys.notAcceptedPrescriptionsMessage.confirm}
         cancelButtonLabel={prescriptionsTranslationKeys.notAcceptedPrescriptionsMessage.cancel}
         content={prescriptionsTranslationKeys.notAcceptedPrescriptionsMessage.message}
         onCancel={onCancel}
         modalWidth={ModalWidth.NORMAL}
         testId={'notAcceptedPrescription'}
      >
         {children}
      </ShowModalEventInterceptor>
   );
};
